module.exports = __webpack_public_path__ + "static/media/app-bar-logo.6a153e80.svg";